import type { Collection } from 'state/utils/types';

export interface AdvisoryUiState {
  isBasketOptimizerAccordionOpened: boolean;
}

export const initialAdvisoryUiState: AdvisoryUiState = {
  isBasketOptimizerAccordionOpened: true,
};

export type AdvisoryUiStateMap = Collection<AdvisoryUiState>;
